// I tipi che il tavolo del sette e mezzo legge. La TMA NON importa QSetteMezzo: sono copiati A MANO da Qlash-IT/QSetteMezzo @ 5633a41c8e23ca10e41c1c6587c4a394d545a47e (main, 2026-10-21), con i tipi della TMA, uno per file:
//   · Posto, Fase, StatoMano, Riepilogo, Vista, Mossa — packages/regole/src/regole.ts (blob e14d656163eee95402ab93fb08b6ef988e47cfc1). La Vista e quella del motore: MAI la coperta
//     di un altro posto ne quella del banco finche sono coperte, MAI l'ordine del tallone (`tallone` e solo QUANTE carte restano). `Stato`, `Azione`, `Config`, `GiocatoreMano`,
//     `Esito`, `Rifiuto` e `EsitoPartita` NON si copiano: sono del server (la config non viaggia nella vista: i limiti di puntata sono `puntataMin` e `puntataMax`).
//   · Carta — kit/gamekit-carte/src/napoletano.ts (blob 0f081f5de6c68b666e70f40af1a5bc66ca2e3e11): un intero 0..39, `seme * 10 + (grado − 1)`, semi nell'ordine denari, coppe, spade, bastoni; e lo STESSO indice della Carta napoletana della TMA
//     (`lib/tavolo/carta.ts`, #734). La matta e il re di denari (indice 9, `MATTA` di packages/regole/src/punti.ts, blob 0f46994d97cf694f1a08d3ffcd038867bdc76311).
//   · MossaDiPersona — apps/qsettemezzo-gameserver/src/regole.ts `puòAgire` (blob 4370f4a0c747a7218abac4ac532c936752c670c5): il server accetta SOLO una delle `mosse(vista)` del
//     posto, e le mosse sono `{ t, posto }` (CARTA, STO) o `{ t, posto, n }` (PUNTA_CARTA, PUNTA_STO), con ESATTAMENTE quelle chiavi (CHIAVI_DELLA_MOSSA). Qui sta la mossa SENZA il posto,
//     che lo mette `componiAzione` (`lib/settemezzo/gioco.ts`) dall'ultimo `table:state`.
// Il resto del protocollo del tavolo (la busta di UN posto, gli eventi, la mescolata verificabile) e del trasporto comune: `lib/gamehost/protocol.ts`.

/** Un posto (0..N-1): il sette e mezzo ne ammette da 2 a 6 nel game host, la TMA apre solo tavoli da 2. */
export type Posto = number;
/** Un intero 0..39: `seme * 10 + (grado − 1)`, semi denari, coppe, spade, bastoni; gradi 1..10 (asso, 2..7, fante 8, cavallo 9, re 10). La matta e il re di denari (9). */
export type Carta = number;

/** La matta: il re di denari (r. 2 del regolamento, §7.1 del report di ricerca). */
export const MATTA: Carta = 9;

export type Fase = 'da-distribuire' | 'in-gioco' | 'da-pagare' | 'finita';

/** Dove sta un posto nella mano: `fuori` = non gioca questa mano (uscito); `attesa` = non ha ancora finito di decidere. */
export type StatoMano = 'fuori' | 'attesa' | 'sta' | 'sballato' | 'settemezzo' | 'salta';

/** Come e finita una mano, pubblico dalla fine della mano. */
export interface Riepilogo {
  mano: number;
  banco: Posto;
  /** la variazione di fiches di ogni posto in quella mano */
  delta: number[];
  /** nessun puntatore ha potuto puntare: la mano conta come banco fatto (r. 12) */
  nulla: boolean;
}

/** Quello che UN posto vede. */
export interface Vista {
  posto: Posto;
  posti: number;
  fase: Fase;
  /** il numero della mano in corso (o della prossima, fra due mani): parte da 0 */
  mano: number;
  banco: Posto;
  /** di chi e il turno (null fra due mani) */
  turno: Posto | null;
  /** il passo del server dopo una carta: nessuno puo agire ora */
  attendeIlServer: boolean;
  fiches: number[];
  uscito: boolean[];
  /** quante mani ha chiuso come banco ogni posto */
  banchi: number[];
  /** i giri di banco per ogni posto presente: le mani sono `giri × posti` */
  giri: number;
  stati: StatoMano[];
  puntate: number[];
  /** le carte che tutti vedono, per posto, in ordine d'arrivo; la coperta c'e solo dopo che e stata scoperta (o alla fase «da pagare») */
  scoperte: Carta[][];
  /** il posto ha ancora una carta coperta: il fatto e pubblico, la carta no */
  coperta: boolean[];
  /** la MIA coperta, se e ancora coperta */
  miaCoperta: Carta | null;
  /** i mezzi punti che chi guarda puo contare per ogni posto: per me tutte le mie carte, per gli altri le sole scoperte */
  punti: number[];
  /** quante carte restano nel tallone (mai quali, ne in che ordine) */
  tallone: number;
  /** la puntata massima che posso fare ora (0 se non devo puntare) */
  puntataMax: number;
  puntataMin: number;
  ultimaMano: Riepilogo | null;
}

/** Una mossa del server (con il posto): e QUESTA la forma che `mosse(vista)` rende e che il game host confronta. */
export type Mossa =
  | { t: 'PUNTA_CARTA'; posto: Posto; n: number }
  | { t: 'PUNTA_STO'; posto: Posto; n: number }
  | { t: 'CARTA'; posto: Posto }
  | { t: 'STO'; posto: Posto };

/** La mossa che sceglie chi gioca: la stessa senza il posto. Il posto lo aggiunge `componiAzione`. */
export type MossaDiPersona = { t: 'PUNTA_CARTA'; n: number } | { t: 'PUNTA_STO'; n: number } | { t: 'CARTA' } | { t: 'STO' };

/** I sotto-codici che un client puo leggere in un rifiuto (`MOTIVI` di apps/qsettemezzo-gameserver/src/regole.ts). */
export const MOTIVI = ['PUNTATA_FUORI_LIMITE', 'TALLONE_FINITO'] as const;
